<script setup lang="ts">
import {ExtendedProject, Subscription} from "@/types";
import {ref} from "vue";
import {router} from "@inertiajs/vue3";

interface Props {
    project: ExtendedProject
    subscription: Subscription
}
const props = defineProps<Props>()

const isDialogOpen = ref(false)
const isLoading = ref(false)

const remove = () => {
    router.delete(route('projects.subscriptions.destroy', {project: props.project.slug, active_subscription: props.subscription.id}), {
        onStart: () => {
            isLoading.value = true;
        },
        onFinish: () => {
            isLoading.value = false;
        },
        onSuccess: () => {
            isDialogOpen.value = false
        }
    })
}
</script>

<template>
    <v-dialog
        v-model="isDialogOpen"
        max-width="500"
        overlay-opacity="0.4"
    >
        <template #activator="{ props: attrs }">
            <default-btn
                v-bind="attrs"
                size="small"
                variant="text"
                rounded="lg"
                class="font-weight-medium text-error rounded border bg-grey-lighten-5"
            >
                Delete
            </default-btn>
        </template>

        <v-card
            :flat="true"
            rounded="lg"
        >
            <v-card-title class="font-weight-bold border-bottom text-body-2 pt-4">
                Are you sure you want to remove this subscriber?
                <v-btn
                    variant="plain"
                    size="small"
                    icon="mdi-close"
                    class="float-end pb-2"
                    @click="isDialogOpen = false"
                />
            </v-card-title>

            <v-card-text class="pt-3 text-black bg-amber-lighten-4">
                <p class="my-5 text-body-2">
                    This action cannot be undone. Future events will no longer be delivered to the configured email address.
                </p>
            </v-card-text>

            <v-divider />

            <v-card-actions class="px-5 py-4">
                <default-btn
                    class="text-error border"
                    rounded="lg"
                    :block="true"
                    :loading="isLoading"
                    @click="remove"
                >
                    Yes, remove this subscriber
                </default-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>
:deep(.v-dialog--active) {
  border-radius: 16px !important;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
